import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { callIfChanged } from 'utilities/forms';

import { generateDistributionData } from 'store/scenes/distributions/actions';
import { getDistributionsFormValues } from 'store/form/distributions/selectors';

import StudentDistributionFieldsComponent from './Component';

class StudentDistributionFieldsContainer extends React.PureComponent {
  static propTypes = {
    generateDistributionData: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    const makeHandleChangeFn = property => callIfChanged((_, newValue) => {
      setTimeout(() => this.props.generateDistributionData({ [property]: newValue }));
    });

    this.handleDofChange = makeHandleChangeFn('dof');
  }

  render () {
    return (
      <StudentDistributionFieldsComponent
        onDofChange={this.handleDofChange}
      />
    );
  }
}

const mapDispatchToProps = {
  generateDistributionData: values => (dispatch, getState) => {
    const distributionFormValues = getDistributionsFormValues(getState());
    dispatch(generateDistributionData({ ...distributionFormValues, ...values }));
  }
};

export default connect(null, mapDispatchToProps)(
  StudentDistributionFieldsContainer
);
